export const halfGridLines = {
    id: 'halfGridLines',
    beforeDraw(chart){

        const { 
            ctx, 
            chartArea: {
                top, bottom, left, width
            },
            config: {
                data: { labels }
            }
        } = chart
        
        const n = labels.length
        const h = Math.round(width/n)

        for (let i=0; i<n; i++){
            ctx.beginPath()
            let x = left + (i + 0.5)*h
            ctx.moveTo(x, top)
            ctx.lineTo(x, bottom)
            ctx.strokeStyle = 'lightgray'
            ctx.lineWidth = 1
            ctx.stroke()
        }

    }
}